module.exports = __webpack_public_path__ + "img/1054974.40c9d988.jpg";